import {Box, Clickable, Icon, Text, ThemeColorPath, ThemeIconKey} from 'platform/foundation';
import styled, {css} from 'styled-components';
import {match} from 'ts-pattern';

import {dec} from 'ramda';

import {DocumentPreviewPage} from '../types/DocumentPreviewPage';
import {UseDocumentPreviewReturnType} from '../types/UseDocumentPreviewReturnType';

interface DocumentPreviewThumbnailsItemProps {
  isActive: boolean;
  documentPage: DocumentPreviewPage;
  documentPreview: UseDocumentPreviewReturnType;
}

export function DocumentPreviewThumbnailsItem(props: DocumentPreviewThumbnailsItemProps) {
  const documentPageIcon = match(props.documentPage.validationStatus)
    .returnType<ThemeIconKey>()
    .with('default', () => 'action/check_circle')
    .with('success', () => 'action/check_circle')
    .with('warning', () => 'alert/error')
    .with('error', () => 'alert/error')
    .otherwise(() => 'action/check_circle');

  const documentPageIconColor = match(props.documentPage.validationStatus)
    .returnType<ThemeColorPath>()
    .with('default', () => 'palettes.neutral.60.100')
    .with('success', () => 'severity.success')
    .with('warning', () => 'severity.warning')
    .with('error', () => 'severity.danger')
    .otherwise(() => 'palettes.neutral.60.100');

  return (
    <Clickable
      onClick={() =>
        props.documentPreview.controls.setActiveIndex(dec(props.documentPage.pageNumber))
      }
    >
      <StyledThumbnailBackgroundWrapper $isActive={props.isActive}>
        <StyledThumbnailContentWrapper>
          <StyledThumbnailWrapper>
            <>
              <StyledThumbnailIconWrapper>
                <Icon value={documentPageIcon} color={documentPageIconColor} size={3} />
              </StyledThumbnailIconWrapper>
              <img
                src={props.documentPage.url}
                alt={`Thumbnail for page ${props.documentPage.pageNumber}`}
                css={css`
                  width: 100%;
                  height: 100%;
                  object-fit: cover; // To match the border radius of image wrapper.
                  border-radius: ${({theme}) => theme.radii.xSmall};
                `}
              />
            </>
          </StyledThumbnailWrapper>
          <Box>
            <Text size="xxSmall" color={props.isActive ? 'white' : 'primary'} align="center">
              {props.documentPage.pageNumber}
            </Text>
          </Box>
        </StyledThumbnailContentWrapper>
      </StyledThumbnailBackgroundWrapper>
    </Clickable>
  );
}

// Disabled eslint for pixels to match design exactly
// eslint-disable-next-line eag/no-css-property
const StyledThumbnailBackgroundWrapper = styled.div<{
  $isActive: boolean;
}>`
  position: relative;
  width: 86px;
  height: 140px;
  padding: 6px;
  border-radius: ${({theme}) => theme.radii.small};
  background-color: ${({$isActive, theme}) =>
    $isActive ? theme.colors.palettes.neutral[100][100] : undefined};
`;

// Disabled eslint for pixels to match design exactly
// eslint-disable-next-line eag/no-css-property
const StyledThumbnailContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

// Disabled eslint for pixels to match design exactly
// eslint-disable-next-line eag/no-css-property
const StyledThumbnailWrapper = styled.div`
  width: 74px;
  height: 106px;
  border-radius: ${({theme}) => theme.radii.xSmall};
  overflow: hidden;
`;

const StyledThumbnailIconWrapper = styled.div`
  position: absolute;
  top: ${({theme}) => theme.getSize(2)};
  right: ${({theme}) => theme.getSize(2)};
`;
